import React, { Component } from 'react';
import { Provider } from '../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../common/ComponentNameContext';
import ConstCommon from '../../common/Const';
import PreRender from './../../common/PreRender';
import MainContent from './MainContent';

class Strategy extends Component {
  render() {
    const { id, glContainer } = this.props;
    return (
      <PreRender {...this.props}>
        <Provider value={id}>
          <ComponentNameProvider
            value={glContainer._config.props.componentName}
          >
            <MainContent {...this.props} />
          </ComponentNameProvider>
        </Provider>
      </PreRender>
    );
  }
}

export default Strategy;
